<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>交流</span><span style="color:#D7230C;">中心</span></div>
							<div class="sm_pub">分享|交流|推荐|评论</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">交流中心</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div class="dtiail_title">{{contents.title}}</div>
						<!-- 上传者信息 -->
						<div style="text-align: center;">
							<span>上传日期：{{getLocalTime(contents.create_time)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传者：{{`${contents.uid}`.substring(0,1)}}&nbsp; *&nbsp;*
								&nbsp;{{`${contents.username}`.substring(3,4)}}</span>
							<!-- <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阅读数：{{contents.view}}</span> -->
						</div>
						<!-- 内容渲染 -->
						<div class="cont_dtiail" v-html="contents.content">
						</div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 100px;margin-top: 20px;">
						<!-- <Xguanyuedu></Xguanyuedu> -->
						<!-- 打赏分享 -->
						<!-- <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> -->
						<div @click="sca"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 35%;">
							<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								收藏
							</div>
						</div>
						<div  @click="getShareInfo"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/weixin1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								微信
							</div>
						</div>
						<div @click="fxkj"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								空间
							</div>
						</div>
						<div @click="das"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;border-radius: 50%;">
							<img class="scname" src="../../../imges/dsdsdsds/dashang1.png"
								style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									打赏
								</div>
						</div>
						<div class="scname" v-if="name=='PPT'" @click="fileDownload(contents)"
							style="width: 100px;height: 30px;line-height: 30px;background-color: red;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;float: left;margin-left: 5px;">
							下载
						</div>
						<!-- <a :href=" 'https://admin.shipoe360.com/public/' +contents.ppt_two " target="_blank" download>
						         <el-button size="small" type="primary">下载</el-button>
						</a> -->
						<div class="scname" v-if="name=='PPT'" @click="yl(contents.ppt_one)"
							style="width: 100px;height: 30px;line-height: 30px;background-color: red;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;float: left;margin-left: 5px;">
							预览
						</div>
					</div>
					<!-- 写下您的问题 - 评论模块 -->
					<div class="user_com">
						<discuss inputName="daka"></discuss>
					</div>
					<!-- 	<div style="width: 95%;margin: 0 auto;height: 140px;border-top: 1px dashed #ddd;">

					</div> -->
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
		<dashang ref="child" :dsje="dsje"></dashang>

		<!-- 微信分享 -->
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				Text: '',
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				dsje: [{
					tid: this.$route.query.id,
					nologin_type: 'dkyj',
					name: '交流中心打赏',
					price: 0,
				}],

				dsasb: false,
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				name: this.$route.query.name,
				contents: '',
				letData: true,
				isShowQR: false, //二维码显示
				QRCodeMsg: '',
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			fileDownload(item) {
				console.log(item)
				let ele = document.createElement('a')
				ele.download = item.title;
				ele.href = 'https://admin.shipoe360.com/public/' + item.ppt_two;
				ele.style.display = 'none';
				document.body.appendChild(ele)
				ele.click();
				document.body.removeChild(ele)
			},
			das() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					this.$refs.child.isShowZF = true //修改子组件data
				} else {
					this.$router.replace('/login')
				}
			},
			yl(val) {
				window.open('https://admin.shipoe360.com/public/' + val)
			},
			getDay() {
				let time = new Date(),
					year = time.getFullYear(),
					month = time.getMonth() + 1,
					day = time.getDate(),
					timeStem = time.getTime()
				return `${year}/${month}/${day}/${timeStem}.pdf`
			},
			fileLinkToStreamDownload(url) {
				console.log(url)
				let fileName = this.getDay()
				let xhr = new XMLHttpRequest()
				xhr.open('get', url, true)
				xhr.setRequestHeader('Content-Type', `application/pdf`)
				xhr.responseType = 'blob'
				let that = this
				xhr.onload = function() {
					if (this.status == 200) {
						//接受二进制文件流
						var blob = this.response
						that.downloadExportFile(blob, fileName)
					}
				}
				xhr.send()
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						console.log(myhref)
						this.Text = myhref
						this.letData = false
						this.isShowQR = true
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			fxa() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						share_url: "http://localhost:8080/#" + this.$route.path + '?id=' + this.id
					};
					location.replace(
						"https://connect.qq.com/widget/shareqq/index.html?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&desc=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			xz(url) {
				this.fileLinkToStreamDownload('https://admin.shipoe360.com/public/' + url)
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					let res = await http.post('api/picture/personal_collection', {
						uid: loginInfo.id,
						title: this.contents.title,
						picture: this.contents.picture,
						pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
						url_link: 'pages/establish/index?id=' + this.id,
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '收藏成功',
							type: 'success'
						});
					} else {
						this.$notify({
							title: '失败',
							message: res.data.msg,
							type: 'error'
						});
					}
				} else {
					this.$router.replace('/login')
				}
			},
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			if (this.name == 'PPT') {
				let res1 = await http.post('api/picture/ppt_details', {
					id: this.id,
				})
				this.contents = res1.data.data.list
				console.log(res1)
			} else {
				// let res1 = await http.post('api/daka/daka_message', {
				// 	id: this.id,
				// })
				let res1 = await http.post('api/picture/jlzx_detail', {
					id: this.id,
				})
				console.log(res1)
				this.contents = res1.data.data.list
			}
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//打赏
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			//评论
			discuss: resolve => require(['@/components/pinglun/discuss.vue'], resolve),
			vueQr,

		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.user_com {
		width: 95%;
		margin-left: 3%;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 100%;
		clear: both;
		overflow: hidden;
		/* height: 1450px; */
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 75%;
		float: left;
	}

	.top_bottom_B {
		width: 25%;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}

	/* 遮罩层 */
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}

	/* 二维码 */
	.qrcode {
		display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;
		background-color: #fff;
		padding: 6px;
	}

	.qrcode>img {
		width: 160px;
		height: 160px;
		box-sizing: border-box;
	}
</style>
